// extracted by mini-css-extract-plugin
export var colorSquare = "_p1-0";
export var danger = "_p1-5";
export var lightPink = "_p1-8";
export var neutralBlue = "_p1-7";
export var neutralYellow = "_p1-6";
export var normal = "_p1-1";
export var primary = "_p1-2";
export var primaryLight = "_p1-3";
export var solidBlack = "_p1-g";
export var solidGreen = "_p1-b";
export var solidLightBlue = "_p1-d";
export var solidNavy = "_p1-c";
export var solidOrange = "_p1-f";
export var solidPink = "_p1-e";
export var solidRed = "_p1-9";
export var solidYellow = "_p1-a";
export var success = "_p1-4";